module.exports = __webpack_public_path__ + "static/technology-banner-mobile-5f010120778f1b261032767b3a58c58c.jpg";